module.exports = __webpack_public_path__ + "static/media/bank-wells-fargo.331a75f5.svg";